/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Display_Default_Background_Color_TransparentInputs */



/**
* | output |
* | --- |
* | "Transparent" |
*
* @param {Options_Display_Default_Background_Color_TransparentInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_display_default_background_color_transparent = /** @type {((inputs?: Options_Display_Default_Background_Color_TransparentInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Display_Default_Background_Color_TransparentInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Transparent")
	if (locale === "de") return /** @type {LocalizedString} */ ("Transparent")
	if (locale === "it") return /** @type {LocalizedString} */ ("Trasparente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Прозрачный")
	if (locale === "es") return /** @type {LocalizedString} */ ("Transparente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("透明")
	if (locale === "ja") return /** @type {LocalizedString} */ ("透明")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पारदर्शी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Transparente")
	return /** @type {LocalizedString} */ ("Transparent")
});